import React, { CSSProperties } from 'react';
import { Field, FieldProps, useFormikContext } from 'formik';
import { FormValues } from '../AddEditTransactionForm/AddEditTransactionForm';
import CurrencyInput from "../../../common/Form/CurrencyInput";

type Props = {
	style?: CSSProperties;
};

const InflowColumn = (props: Props) => {
	const { setFieldValue } = useFormikContext<FormValues>();
	return (
		<div className={'add-transaction-row__main-row-cell'} style={props.style}>
			<Field name="inflow">
				{(props: FieldProps) => (
					<CurrencyInput
						{...props.field}
						name={'inflow'}
						className={'add-transaction-row__input'}
						onChange={() => {
							setFieldValue('outflow', 0);
						}}
						onBlur={(newValue: number) => {
							newValue !== 0 && setFieldValue('outflow', 0);
							setFieldValue('inflow', newValue);
						}}
					/>
				)}
			</Field>
		</div>
	);
};

export default InflowColumn;
